module.exports = __webpack_public_path__ + "static/media/shuffle.45f1850f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/cards/shuffle.svg
// module id = 73
// module chunks = 0